export function normaliseArtistName(value) {
  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
}

export function initialiseArtistDirectory(directory) {
  const input = directory.querySelector('[data-artist-search]');
  const tools = directory.querySelector('[data-artist-tools]');
  const count = directory.querySelector('[data-artist-count]');
  const clear = directory.querySelector('[data-artist-clear]');
  const empty = directory.querySelector('[data-artist-empty]');
  const cards = [...directory.querySelectorAll('[data-artist-name]')];
  if (!input || !tools || !count || !clear || !empty) return;
  const names = cards.map(card => normaliseArtistName(card.dataset.artistName));
  function update() {
    const query = normaliseArtistName(input.value);
    let visible = 0;
    cards.forEach((card, index) => {
      card.hidden = !names[index].includes(query);
      if (!card.hidden) visible += 1;
    });
    count.textContent = query ? `${visible} of ${cards.length} artists` : `${cards.length} ${cards.length === 1 ? 'artist' : 'artists'}`;
    clear.hidden = !input.value;
    empty.hidden = visible > 0 || cards.length === 0;
  }
  function reset() { input.value = ''; update(); input.focus(); }
  tools.addEventListener('submit', event => event.preventDefault());
  input.addEventListener('input', update);
  clear.addEventListener('click', reset);
  directory.querySelector('[data-artist-reset]')?.addEventListener('click', reset);
  tools.hidden = false;
  update();
}

if (typeof document !== 'undefined') {
  document.querySelectorAll('[data-artist-directory]').forEach(initialiseArtistDirectory);
}
